module.exports = __webpack_public_path__ + "static/media/ban-khar-map.5de9c724.svg";